import * as React from 'react';
import { UpdateRequired } from '@relay-towing/ui';
import { useUpdateRequired } from '../hooks/useUpdateRequired';
import { openExternal } from '../lib/nativeBridge';

/**
 * The whole app, unless this wrapper build is older than the server allows;
 * then only the update screen, with no way past it. It sits outside sign-in,
 * because a build that old may not be able to sign in at all.
 */
export function UpdateGate({ children }: { children: React.ReactNode }) {
  const update = useUpdateRequired();
  if (!update) return <>{children}</>;
  return (
    <UpdateRequired
      store={update.store}
      onUpdate={() => openExternal(update.url)}
    />
  );
}
